import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["links", "template"];

  connect() {
    this.wrapperClass = this.data.get("wrapperClass") || "nested-fields";
  }

  add_association(event) {
    event.preventDefault();

    var content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime()
    );
    this.linksTarget.insertAdjacentHTML("beforebegin", content);

    // Update parent collapsible section height after adding
    this.updateParentSectionHeight();
  }

  remove_association(event) {
    event.preventDefault();

    let wrapper = event.target.closest("." + this.wrapperClass);

    // New records are simply removed from the page
    if (wrapper.dataset.newRecord == "true") {
      wrapper.remove();

      // Existing records are hidden and flagged for deletion
    } else {
      wrapper.querySelector("input[name*='_destroy']").value = 1;
      wrapper.style.display = "none";
    }

    // Update parent collapsible section height after removing
    this.updateParentSectionHeight();
  }

  updateParentSectionHeight() {
    // Find the parent collapsible section
    const collapsibleSection = this.element.closest(
      '[data-controller*="collapsible-section"]'
    );
    if (collapsibleSection) {
      const bodyElement = collapsibleSection.querySelector(
        "[data-collapsible-section-target='body']"
      );
      if (bodyElement) {
        // Update max-height to accommodate new content
        requestAnimationFrame(() => {
          bodyElement.style.maxHeight = bodyElement.scrollHeight + "px";
        });
      }
    }
  }
}
